import styled from 'styled-components'

export const StyleForMixedShift = styled('div')`
{
  width: 606px;
  margin: 0 auto;
};
`